/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Entitlement_SetInputs */



/**
* | output |
* | --- |
* | "Granted a plan feature" |
*
* @param {Activity_Entitlement_SetInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_entitlement_set = /** @type {((inputs?: Activity_Entitlement_SetInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Entitlement_SetInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выдана функция тарифа")
	return /** @type {LocalizedString} */ ("Granted a plan feature")
});